import styled from "@emotion/styled/macro";
import { env } from "../../helpers/env";
import { PlaybookIframe } from "../atoms/PlaybookIframe";

const PLAYBOOK_URL =
  env === "production"
    ? "https://saleschat.ai.sunrun.com/pdf-annotator/playbook"
    : "https://saleschat.staging.ai.sunrun.com/pdf-annotator/playbook";

const Headline = styled.div`
  display: flex;
  font-family: Roobert;
  justify-content: space-between;
  align-items: center;
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  margin-bottom: 24px;
`;

const Container = styled.div`
  margin: 2%;
  width: 95%;
`;

// Playbook (sales-experience, the top container) is the source of truth for
// every cross-iframe message (`EVENT:AUTH_TOKEN`, `QUERY:AUTH_TOKEN`,
// `COMMAND:LOGOUT`, `COMMAND:CHANGE_URL`, etc.). The Chat app is rendered here
// as a nested iframe, so it would otherwise be invisible to the bus. This page
// acts as a transparent two-way pipe between Playbook.
const PlaybookPage = () => {
  return (
    <div className="App" data-testid="playbook-page">
      <Container>
        <Headline>
          <p style={{ margin: 0 }}>Playbook</p>
        </Headline>
        <PlaybookIframe src={PLAYBOOK_URL} />
      </Container>
    </div>
  );
};

export { PlaybookPage };
